import * as React from 'react'
import { CodeBlock } from '../../../ui/codeBlock'

interface Props {
    message?: {
        args: {
            wt: number
            ct: number
        }
    }
}

export default class DiDeveloperMode extends React.PureComponent<Props> {
    render = () => {
        const { message } = this.props

        return (
            <div>
                <p>
                    The ObjectManager in Magento 2 must be compiled for efficient use in production. This must be made during the deployment
                    of the Magento application, after a release or after every code change on the server. The command for this is:
                </p>
                <CodeBlock code="php bin/magento setup:di:compile" language={'bash'}></CodeBlock>
                <p>This should be performed before dumping and optimizing the Composer autoloader.</p>
                <p>If you run &quot;setup:upgrade&quot; afterwards this can negate the compiled container, unless you pass a flag:</p>
                <CodeBlock code="php bin/magento setup:upgarde --keep-generated" language={'bash'}></CodeBlock>
            </div>
        )
    }
}
